import TourService from './Service'
import { getStore } from '@/store/StoreInstance';

// vars and functions to support tour scrolling
let opts;
let wfStep;
function targetIsVisible() {
  let viewTop = $(window).scrollTop();
  let viewBottom = viewTop + $(window).height();
  let target = $(opts.attachTo.element);
  let targetTop = target.offset().top;
  let targetBottom = targetTop + target.height();
  let isVisible = !(targetTop >= viewBottom || targetBottom <= viewTop);
  if(isVisible) {
    $('.tour-modal').show();
  }
  else {
    $('.tour-modal').hide();
  }
}
function addScrollListener() {
  window.addEventListener('scroll', targetIsVisible);
}
function addWorkflowScrollListener() {
  window.addEventListener('scroll', scrollingStop)
}
function removeScrollListener() {
  window.removeEventListener('scroll', scrollingStop)
  window.removeEventListener('scroll', targetIsVisible);
}

const scrollIntoViewWithOffset = (el, offset) => {
  window.scrollTo({
    behavior: 'smooth',
    top:
      el.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  })
}
const isInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}


const scrollingStop = () => {
  let isScrolling
  let checkForScrollStop = () => {
    let currentStep = wfStep.tour.getCurrentStep()
    let inView = isInViewport(currentStep.getTarget())
    window.clearTimeout(isScrolling);
    const scrollTillElementInView = () => {
      if(inView) {
        currentStep.getElement().classList.remove('temp-hide')
        window.removeEventListener('scroll', scrollingStop)
        return true
      }
    }
    isScrolling = setTimeout(scrollTillElementInView, 150)
  }
  checkForScrollStop()
}

const bsWfMobileFn = (tour, el) => {
  if (tour.currentStep.id === 'intro') return
  if(tour.currentStep.id !== 'workflow-step-3') {
    addWorkflowScrollListener()
    let inView = isInViewport(el)
    if (!inView) {
      scrollIntoViewWithOffset(el, 110)
    } 
    else {
      tour.currentStep.getElement()?.classList.remove('temp-hide')
      scrollIntoViewWithOffset(el, 110)
    }
  }
}

const defaults = (tour) => {
  let tourName = tour.options.tourName
  let setHighlightClass = () => (tourName !== 'eln') ? 'tourHighlightClass' : 'no-click'
  return {
    highlightClass: setHighlightClass(),
    canClickTarget: false,
  	popperOptions: {
  		modifiers: [
        {
          name: 'offset',
          options: {
            offset: ({ placement, reference, popper }) => {
              const positions = {
                'bottom-end': [0, 26],
                'bottom-start': [0, 26],
                'right-start': [-5, 26],
                'top-end': [0, 16],
                'top-start': [0, 16],
                'default': [0,0]
              }
              return positions[placement] ? positions[placement] : positions['default']
            }
          }
        },
        {
          name: 'arrow',
          options: {
            padding: ({ popper, reference, placement }) =>{
              const positions = {
                'bottom-end': popper.width - (32+22),
                'top-end': -100,
                'default': 0
              }
              return positions[placement] ? positions[placement] : positions['default']

            }
          },
        },
      ],
  	},
  	when: {
  		async show() {
  			let { tour } = this;
  			const currentStepElement = tour.currentStep.el;
        const stepTarget = tour.currentStep.getTarget()
        let isMobile = tour.options.mobile;
  			if (tour.options.tourName === 'finder') {
          await new Promise(resolve => setTimeout(()=>{
          if (stepTarget.id !='show-workflow-btn') {
            stepTarget.__vue__.focusOpener()
          } else if(tour.currentStep.id !== 'workflow-step-3'){
            stepTarget.focus()
          }
          resolve()
          }, 500))
          return;
        }
  			TourService.getHeader(tour, currentStepElement, isMobile);
        TourService.getFooter(currentStepElement);
  		},
      'before-show'() {
        let { options, tour, id, _scrollTo } = this;
        let el = document.querySelector(options.attachTo.element);
        // adds class which adds highlight to modal header button
        if (tour.options.tourName === 'product' && (id === "product-tour-step-4" || id === "product-tour-step-2")) {
          el.parentElement.classList.add('button-index');
        }
        if (!el && id !== 'intro') {
  				tour.next();
  			}
        if (tour.options.mobile && tour.options.tourName === 'workflow') {
          //step accessible outside obj
          wfStep = this
          bsWfMobileFn(tour, el)
        }
        if(id !== 'intro') {
          opts = options;
          // if tour is 'finder'...
          if(tour.options.hasOwnProperty('tourName') && tour.options.tourName == 'finder') {
            // if media is mobile, then use default scroll behavior
            if(tour.options.mobile) {
              scrollIntoViewWithOffset(el, 84)
            }
          }
          // if tour is not 'finder'
          else if (tour.options.tourName !== 'product') {
            // use 'workflow' scroll behavior
            window.scroll(0, el.offsetTop - el.offsetHeight);
            if(tour.options.tourName !== 'workflow') {
              addScrollListener();
            }
          }
        }
      },
  		hide() {
        let { tour, id } = this;
        let tourName = tour.options.tourName;
        $(`[data-${tourName}-tour-shepherd-step-id=${id}]`).css('visibility', 'hidden');
      },
      'before-hide' () {
        let { tour, id } = this;
        // removes class which adds highlight to modal header button
        if (tour.options.tourName === 'product') {
          let el = document.querySelector('#options-modal-wrapper .wrapper-header.tour-zindex .right-side')
          if (el.classList.contains('button-index') || id === "product-tour-step-2" ) {
            el.classList.remove('button-index')
          }
        }
      },
    }
  }
};

const getTourButtons = (tour) => {
  return {
    'cancel' : {
      classes:'md-button md-theme-default md-secondary md-button-large button',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Skip</div></div>',
      action: () => {
        wfStep = null
        removeScrollListener();
        getStore().dispatch('tour/setTourFlag', false);
        tour.cancel();
        if(tour.options.tourName == 'eln') {
          $('#eln-first-accordion').click();
        }
        window.scroll(0, 0);
      }
    },
    'back' : {
      classes:'md-button md-theme-default md-secondary md-button-large button previous',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Previous</div></div>',
      async action(){
        const {options: {mobile, tourName}, currentStep: { options }} = this
        if (tourName === "product" && mobile && options.id === "product-tour-step-3") {
          handleMobileProductTourBack(this)
        } else {
          return this.back()
        }
      }
    },
    'next' : {
      classes:'md-button md-theme-default md-primary md-button-large button next',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Next</div></div>',
      action: () => {
        tour.next()
      }
    },
    'finish' : {
      classes:'md-button md-theme-default md-primary md-button-large button next',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Finish</div></div>',
      action: () => {
        wfStep = null
        removeScrollListener();
        getStore().dispatch('tour/setTourFlag', false);
        tour.complete();
        if(tour.options.tourName == 'eln') {
          $('#eln-first-accordion').click();
        }
        window.scroll(0, 0);
      }
    },
    'introN' : {
      classes:'md-button md-theme-default md-primary md-button-large button',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Start Tour</div></div>',
      action: tour.next
    },
    'introC' : {
      classes:'md-button md-theme-default md-secondary md-button-large button',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Skip for now</div></div>',
      action: () => {
        removeScrollListener();
        getStore().dispatch('tour/setTourFlag', false);
        tour.cancel();
        window.scroll(0, 0);
      }
    },
    'modalSelectProductGroup' : {
      classes:'md-button md-theme-default md-primary md-button-large button',
      text: '<div class="md-ripple shepherd-md-ripple"><div class="md-button-content"> Next</div></div>',
      async action(){
        await document.querySelector('.product-tour-step-2').click()
        tour.next()
      }
    }
  }
}
const handleMobileProductTourBack = async (tour) => {
  const el = document.querySelector('#options-modal-wrapper .wrapper-header.tour-zindex .right-side')
  el.classList.add('button-index')
  tour.options.vInstance._data.step = 0
  tour.options.vInstance._data.chipsView = false
  await new Promise(resolve => setTimeout(()=>{
    resolve()
    return tour.back()
  }, 0))
}
const setAttachTo = (tourData, mobile) => {
  let attachOn;
  let isTabletView = getStore().getters['tour/getisTabletView'];
  if((isTabletView || mobile) && tourData.hasOwnProperty('mobileAttachOn')) {
    attachOn = tourData.mobileAttachOn;
  } else {
    attachOn = tourData.attachOn;
  }
  return {
    element: tourData.attachToElement,
    on: attachOn
  }
}
const setButtons = (tour, tourData, mobile) => {
  if (!tourData.buttons) return
  const buttons = [];
  let buttonProp = 'buttons';
  if(mobile && tourData.hasOwnProperty('mobileButtons')) {
    buttonProp = 'mobileButtons';
  }
  tourData[buttonProp].forEach(type => {
    buttons.push(getTourButtons(tour)[type])
  })
  return buttons;
}
const setTitle = (tourData, mobile) => {
  if(mobile && tourData.hasOwnProperty('mobileTitle')) {
    return tourData.mobileTitle;
  }
  else {
    return tourData.title;
  }
}
export class Step {
  id = null
  classes = null
  modalOverlayOpeningRadius = null
  modalOverlayOpeningPadding = null
  title = null
  text = null
  buttons = null
  canClickTarget = null
  recreateButtons (tour, buttonsList) {
    this.buttons = []
    buttonsList.forEach(type => {
      this.buttons.push(getTourButtons(tour)[type])
    })
  }
  constructor(tour, tourData, mobile) {
    this.id = tourData.id || ''
    this.classes = tourData.classes
    this.arrow = tourData.arrow
    this.attachTo = setAttachTo(tourData, mobile)
    this.modalOverlayOpeningRadius = tourData.modalOverlayOpeningRadius || ''
    this.modalOverlayOpeningPadding = tourData.modalOverlayOpeningPadding || ''
    this.title = setTitle(tourData, mobile)
    this.text = tourData.text
    this.buttons = setButtons(tour, tourData, mobile)
    this.advanceOn = tourData.advanceOn
    this.showOn = () => {
      if(tourData.id == 'intro') {
        tourData.exclude = false;
        return true;
      }
      tourData.exclude = true;
      return document.querySelector(tourData.attachToElement) ? true : false;
    }
    Object.assign(this, defaults(tour))
  }
}
